import React, { useState, useEffect, useRef, useCallback } from 'react';

import { Row, Col, Alert, Select } from 'antd';

import { BarLoader } from 'react-spinners';

import { IoMdArrowBack } from 'react-icons/io';

import { toast } from 'react-toastify';

import Swal from 'sweetalert2';

import { CSVLink } from 'react-csv';

import history from '~/services/history';

import api from '~/services/api';

import { store } from '~/store';

import Breadcumbs from '~/components/Breadcumbs';

import {
  PageTitle,
  BoxAuth,
  BoxUpload,
  BoxSendButton,
  BoxInstructions,
  BoxFichaColeta,
} from './style';

import iconFicha from '~/assets/icons/icon-ficha-coleta.svg';

import { messageAlert } from './messages';

import template_acidente_vascular_cerebral from '~/assets/templates/template-avc';
import template_cancer_de_prostata from '~/assets/templates/template-prostata';
import template_artropatia_de_quadril from '~/assets/templates/template-quadril';
import template_sindrome_coronariana_aguda from '~/assets/templates/template-sca';
import template_sepse_e_choque_septico from '~/assets/templates/template-sepse';
import template_mam from '~/assets/templates/template-mam';

import {
  getIndicadorLC,
  getNomeIndicador,
  getTitleIndicador,
  routersLc,
} from './careLinesInfo';

const { Option } = Select;

const AdicionarLinhaDeCuidado = props => {
  const { token, cnes } = store.getState().auth;

  const [ondragoverError, setOndragoverError] = useState(false);

  const [csvFile, setCsvFile] = useState(null);

  const [indicadorLinhaDeCuidado, SetIndicadorLinhaDeCuidado] = useState('');
  const [
    indicadorLinhaDeCuidadoValue,
    SetIndicadorLinhaDeCuidadoValue,
  ] = useState('');

  const [periodoSelecionado, setPeriodoSelecionado] = useState(null);

  const [competencias, setCompetencias] = useState([]);

  const [titlePage, setTitlePage] = useState('');

  const [lc, setLc] = useState('');

  const [loadingFile, setLoadingFile] = useState(false);

  const [templateCsv, setTemplateCsv] = useState(
    template_acidente_vascular_cerebral
  );

  const idInst = sessionStorage.getItem('institutionId');

  const inputUploadRef = useRef(null);

  const templateFileName = `${lc}${cnes}${periodoSelecionado?.replace(
    '/',
    ''
  )}`;

  const clearUploadInput = useCallback(() => {
    if (inputUploadRef?.current) {
      inputUploadRef.current.value = null;
    }
    setCsvFile(null);
  }, []);

  const obterCompetencia = async linha => {
    setCompetencias([]);
    try {
      const response = await api.get(
        `indicadores-linhas-de-cuidado/${linha}/instituicoes/${idInst}/competencias`,
        {
          headers: {
            Authorization: token,
          },
        }
      );

      setCompetencias(response.data.sort().reverse());
    } catch (error) {
      //
    }
  };

  const enviarLinhaDeCuidado = async () => {
    if (!periodoSelecionado) {
      messageAlert(
        'Selecione primeiro o período em seguida o arquivo para envio.'
      );

      return;
    }

    const formData = new FormData();
    formData.append('arquivo', csvFile);
    formData.append('periodo', periodoSelecionado);
    formData.append('senha', null);

    setLoadingFile(true);

    try {
      const response = await api.post(
        `indicadores-linhas-de-cuidado/${indicadorLinhaDeCuidadoValue}`,
        formData,
        {
          headers: {
            Authorization: token,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      Swal.fire({
        title: 'Obrigado!',
        text: `${String(response?.data?.menssagem)}`,
        icon: 'success',
        confirmButtonColor: '#74a50a',
        confirmButtonText: 'Ok! Obrigado!',
      }).then(() => {
        history.push({
          pathname: `/linha-de-cuidado/${indicadorLinhaDeCuidadoValue}`,
          state: {
            periodo: periodoSelecionado,
          },
        });
      });

      setLoadingFile(false);
      setCsvFile(null);

      console.log('response :', response);
    } catch (error) {
      if (error.response?.data?.cause === 'invalid_care_line') {
        Swal.fire({
          title: 'Atenção',
          text: `${error?.response?.data?.error}`,
          icon: 'error',
          confirmButtonColor: '#74a50a',
        });
        clearUploadInput();
        setLoadingFile(false);
        return;
      }

      if (error.response?.data?.fields?.length > 0) {
        // let ext = error.response?.data?.fields.filter(
        //   x => x.parameter == 'extensao_arquivo'
        // );
        // let name = error.response?.data?.fields.filter(
        //   x => x.parameter == 'nome_arquivo'
        // );
        // let msg = '';
        // if (ext?.length > 0) {
        //   msg += '<b>' + ext[0].exception + '</b></br>';
        // }
        // if (name?.length > 0) {
        //   msg += msg.length > 0 ? '</br>' : '';
        //   msg += '<b>Nome do arquivo incorreto. </b></br>';
        //   msg += '<b>Formato aceito: LC-CNES-MÊS-ANO (sem os traços) </b></br>';
        //   msg += 'CNES da Instituição</br>';
        //   name.forEach(r => {
        //     msg += r.exception + '</br>';
        //   });
        // }
        Swal.fire({
          title: 'Atenção',
          width: '40%',
          html: `<b>Nome do arquivo incorreto. </b></br>
                 <b>Formato aceito: LC-CNES-MÊS-ANO (sem os traços) </b></br>
                 CNES da Instituição</br>
                 Linha de cuidado (sigla com três caracteres)</br>
                 Mês com dois dígitos</br>
                 Ano com quatro dígitos.</br>`,
          icon: 'error',
          confirmButtonColor: '#74a50a',
        }).then(() => {
          // remove arquivo selecionado
          clearUploadInput();
        });
        setLoadingFile(false);
      } else {
        Swal.fire({
          title: 'Atenção',
          text: `${error.response.data.error}`,
          icon: 'error',
          confirmButtonColor: '#74a50a',
        }).then(() => {
          history.push({
            pathname: `/relatorio-de-inconsistencias/${indicadorLinhaDeCuidadoValue}`,
            state: {
              periodo: periodoSelecionado,
            },
          });
          setLoadingFile(false);
          setCsvFile(null);
          setPeriodoSelecionado(null);
        });
      }
    }
  };

  useEffect(() => {
    if (csvFile) {
      enviarLinhaDeCuidado();
    }
  }, [csvFile]);

  useEffect(() => {
    if (csvFile) {
      enviarLinhaDeCuidado();
    }
  }, [periodoSelecionado]);

  useEffect(() => {
    try {
      const inputFileFied = document.getElementById('BoxUpload');
      inputFileFied.ondragover = () => {
        setOndragoverError(true);
      };
    } catch (error) {
      setOndragoverError(false);
    }
    // getListLinhasDeCuidado();
  }, []);

  useEffect(() => {
    if (periodoSelecionado) {
      competencias.forEach(item => {
        if (item.competencia === periodoSelecionado && item.enviado) {
          toast.info('Já existem dados prévios para essa competência.', {
            autoClose: 7000,
          });

          history.push({
            pathname: `/linha-de-cuidado/${indicadorLinhaDeCuidadoValue}`,
            state: {
              periodo: periodoSelecionado,
            },
          });
        }
      });
    }
  }, [periodoSelecionado]);

  const handleCsvFile = e => {
    setCsvFile(e.target.files[0]);
  };

  useEffect(() => {
    const { indicador } = props.match.params;

    const nomeIndicador = getNomeIndicador(indicador);

    const indicadorLC = getIndicadorLC(indicador);

    const titleIndicador = getTitleIndicador(indicador);

    setLc(indicadorLC);

    SetIndicadorLinhaDeCuidado(nomeIndicador);
    SetIndicadorLinhaDeCuidadoValue(indicador);
    setTitlePage(titleIndicador);
    obterCompetencia(indicador);

    setTemplateCsv(
      (indicador === 'acidente_vascular_cerebral' &&
        template_acidente_vascular_cerebral) ||
        (indicador === 'artropatia_de_quadril' &&
          template_artropatia_de_quadril) ||
        (indicador === 'cancer_de_prostata' && template_cancer_de_prostata) ||
        (indicador === 'sepse_e_choque_septico' &&
          template_sepse_e_choque_septico) ||
        (indicador === 'sindrome_coronariana_aguda' &&
          template_sindrome_coronariana_aguda) ||
        (indicador === 'cancer_de_mama' && template_mam)
    );
  }, [props]);

  useEffect(() => {
    if (ondragoverError) {
      toast.warn('Clique na área destacada para selecionar um arquivo .CSV.');
    }
  }, [ondragoverError]);

  const FichaDeColeta = () => {
    if (routersLc[lc]) {
      history.push({
        pathname: `/formulario-linhas-de-cuidado/${routersLc[lc]}`,
        state: {
          periodo: periodoSelecionado,
          indicador: indicadorLinhaDeCuidadoValue,
          indicadorNome: indicadorLinhaDeCuidado,
        },
      });

      return;
    }

    // history.push({
    //   pathname: `/formulario-linha-de-cuidado/${indicadorLinhaDeCuidadoValue}`,
    //   state: {
    //     periodo: periodoSelecionado,
    //     indicador: indicadorLinhaDeCuidadoValue,
    //     indicadorNome: indicadorLinhaDeCuidado,
    //   },
    // });
  };

  const handleSetPeriodo = useCallback(value => {
    clearUploadInput();
    setPeriodoSelecionado(value);
  }, []);

  return (
    <>
      <Breadcumbs
        path={`${indicadorLinhaDeCuidadoValue}`}
        pathTitle={`Adicionar Indicadores de Linhas de Cuidado / ${titlePage}`}
      />
      <PageTitle>
        <div className="voltar">
          <button type="button" onClick={() => history.goBack()}>
            <IoMdArrowBack size={15} /> Voltar
          </button>
        </div>
        <div>
          <span>{titlePage}</span>
        </div>
      </PageTitle>
      <BoxAuth>
        <div className="BoxAuthContainer">
          <div className="title">
            {periodoSelecionado ? (
              <h2>
                Escolha a melhor forma de <span>iniciar</span>
                <br />o envio de dados:
              </h2>
            ) : (
              <h2>
                Selecione o <span>mês de competência</span>
                <br /> para envio de dados:
              </h2>
            )}
          </div>

          <div className="selectMonth">
            <Select
              showSearch
              style={{ width: 320 }}
              placeholder="Escolha a competência"
              onChange={value => {
                handleSetPeriodo(value);
              }}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {competencias.length > 0 &&
                competencias.map(({ competencia }) => {
                  return (
                    <Option key={competencia} value={competencia}>
                      {competencia}
                    </Option>
                  );
                })}
            </Select>
          </div>

          {periodoSelecionado && (
            <Row>
              <Col span={12} className="colInsercao">
                <h2>Importação de dados</h2>
                <BoxUpload id="BoxUpload">
                  <form id="fileUploadForm">
                    <label htmlFor="fileUpload">
                      <input
                        type="file"
                        accept=".csv"
                        id="fileUpload"
                        ref={inputUploadRef}
                        onChange={e => handleCsvFile(e)}
                      />
                    </label>
                    {loadingFile ? (
                      <div className="loadingFile">
                        <BarLoader
                          css={{ width: '200px' }}
                          size={288}
                          color="#74a50a"
                          loading={loadingFile}
                        />
                        <span>Enviando, aguarde...</span>
                      </div>
                    ) : (
                      <>
                        <BoxSendButton>
                          <button type="button">Enviar arquivo .csv</button>
                        </BoxSendButton>
                        <p id="fileSelected"> </p>
                        <span className="fileUploadText">
                          {csvFile != null ? (
                            <>
                              Arquivo selecionado: <br />
                              {csvFile.name}
                              <br />
                              <br />
                            </>
                          ) : (
                            <>
                              Busque o arquivo para <br /> fazer upload.
                              <br />
                            </>
                          )}
                        </span>
                      </>
                    )}
                  </form>
                </BoxUpload>

                <BoxInstructions>
                  <span>Dúvidas sobre o padrão requerido?</span>

                  <p>
                    <CSVLink
                      filename={`${templateFileName}.csv`}
                      data={templateCsv}
                      title="Baixe aqui o template do arquivo CSV com instruções."
                    >
                      Baixe aqui o template do arquivo
                      <br /> CSV com instruções.
                    </CSVLink>
                  </p>
                </BoxInstructions>

                <div className="alertMessage">
                  <Alert
                    message="ATENÇÃO: Essa forma de envio permite que você complemente os dados, manualmente, após envio do arquivo com extensão “.csv”."
                    type="success"
                  />
                </div>
              </Col>

              <Col span={12}>
                <h2>Inserção manual de dados</h2>

                <BoxFichaColeta>
                  <img src={iconFicha} alt="Ficha de coleta" />
                  <span>Ficha de coleta</span>
                  <button
                    type="button"
                    className="botao-verde"
                    onClick={FichaDeColeta}
                  >
                    Ficha de coleta
                  </button>
                </BoxFichaColeta>

                <div className="alertMessage" style={{ maxWidth: '320px' }}>
                  <Alert
                    message="ATENÇÃO: Apenas inserção manual."
                    type="success"
                  />
                </div>
              </Col>
            </Row>
          )}
        </div>
      </BoxAuth>
    </>
  );
};

export default AdicionarLinhaDeCuidado;
